import { requireAuthentication } from '@/modules/auth/routes/middleware'

export default [
  {
    component: () => import('../pages/goodbye-page.vue'),
    name: 'public.goodbye',
    path: '/goodbye',
  },
  {
    component: () => import('../pages/welcome-page.vue'),
    name: 'public.welcome',
    path: '/:slug',
  },
  {
    component: () => import('../pages/groups/apply.vue'),
    name: 'public.groups.apply',
    path: '/groups',
  },
  {
    component: () => import('../pages/companies/apply.vue'),
    name: 'public.companies.apply',
    path: '/:slug/companies/apply',
    beforeEnter: requireAuthentication,
  },
  {
    component: () => import('../pages/investors/apply.vue'),
    name: 'public.investors.apply',
    path: '/:slug/investors/apply',
    beforeEnter: requireAuthentication,
  },
  {
    component: () => import('../pages/investors/apply.vue'),
    name: 'public.group-users.apply',
    path: '/:slug/groups/apply',
    beforeEnter: requireAuthentication,
  },
]
